import { useTranslation } from 'react-i18next';
import InformationPopup from '../../informationPopup/informationPopup';

interface LinkedItemNotFoundModalProps {
  title: string;
  onConfirm: () => void;
}

const LinkedItemNotFoundModal = ({ title, onConfirm }: LinkedItemNotFoundModalProps) => {
  const { t } = useTranslation();

  return (
    <InformationPopup
      visible
      title={title}
      subtitle={t('common:unlinkRemovedItemConfirmationText')}
      confirmText={t('common:unlink')}
      onConfirm={onConfirm}
    />
  );
};

export default LinkedItemNotFoundModal;
